export default __webpack_public_path__ + "static/media/diagnosis_img_placeholder.99e5651c.png";